import React from 'react';
import Center from '../Center';

const Error404: React.FC<{}> = () => {
  return <Center>Page not found :(</Center>
}

export default Error404;
